// //functional imports
import React, { useState } from 'react'
// //custom componets
// //main css
// //static files



const MultilineText = ({ children }) => {

    //component view
    return (
        <div>
            {children.split("\\r\\n").map((i, key) => {
                return <p key={key}>{i}</p>;
            })}
        </div>
    );

};


//styles
const style = {
}

//export componet
export default MultilineText;



